import Super9 from "./Super9";

export default Super9;
